import { Box, Button, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from "@mui/material";
import React, { useMemo, useState } from "react";
import { useGetCultureQuotesQuery } from "../../api/apiSlice";
import { Table } from "../../components";
import { OneLiner } from "../../components/Table/Table";
import { userFriendlyDateTimestamp } from "../../utils/timestamps";
import { IPreviewCulture, TabLabelEnum } from "../../utils/types";

interface Props {
  culture: IPreviewCulture;
  handleClose: () => void;
}

export const ViewCultureQuotes: React.FC<Props> = props => {
  const { culture, handleClose } = props;

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const {
    data: rowData,
    isLoading,
    isFetching,
  } = useGetCultureQuotesQuery({
    id: culture.id,
    per_page: pagination.pageSize,
    page: pagination.pageIndex + 1,
  });

  const columns = useMemo(() => {
    return [
      { accessorKey: "engText", header: "Quote", size: 200, Cell: ({ row }: any) => <OneLiner text={row.original.engText} /> },
      { accessorKey: "origLang", header: "Origin Language" },
      {
        accessorKey: "origText",
        header: "Origin Language Text",
        size: 300,
        Cell: ({ row }: any) => <OneLiner text={row.original.origText} />,
      },
      {
        accessorKey: "origTimePeriod",
        header: "Origin Time Period",
      },
      {
        accessorKey: "published",
        header: "Status",
        Cell: ({ row }: any) =>
          row.original.published === 0
            ? TabLabelEnum.Unpublished
            : row.original.published === -1
              ? TabLabelEnum.ReadyForReview
              : row.original.published === -2
                ? TabLabelEnum.Archived
                : TabLabelEnum.Published,
      },
      { accessorKey: "views", header: "Views" },
      { accessorKey: "likes", header: "Likes" },
      {
        accessorKey: "createdAt",
        header: "Created At",
        Cell: ({ row }: any) => userFriendlyDateTimestamp(row.original.createdAt),
      },
    ];
  }, []);

  return (
    <Box>
      <DialogTitle>
        <Typography variant="h6">Quotes in "{culture.culture}" culture</Typography>
      </DialogTitle>
      <DialogContent>
        {!isLoading && !isFetching && rowData?.total === 0 ? (
          <Box sx={{ display: "flex", justifyContent: "center", my: 5 }}>
            <DialogContentText id="alert-dialog-description">No quotes found for this culture</DialogContentText>
          </Box>
        ) : (
          <Table
            enableStickyHeader
            columns={columns}
            data={rowData?.data ?? []}
            manualPagination
            onPaginationChange={setPagination}
            state={{ pagination }}
            rowCount={rowData?.total ?? 0}
            loading={isLoading || isFetching}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button disableElevation variant="outlined" sx={{ width: 100, borderRadius: "20px" }} onClick={handleClose} type="button">
          Cancel
        </Button>
      </DialogActions>
    </Box>
  );
};
